const axios = require('axios').default;
import PostUtil from './post.js';


export default {

  cms: 'https://www.radio-bollwerk.ch/wp-json/wp/v2/posts',
  mixlr: 'https://api.mixlr.com/users/8514762?source=embed',
  airTime: 'https://radiobollwerk.airtime.pro/api/live-info-v2',

  async getMixlrInfo() {
    const data = {
      onAir: false,
      text: ''
    };

    try {
      const response = await axios.get(this.mixlr);

      data.onAir = response.data.is_live

      if (response.data && response.data.broadcasts && response.data.broadcasts.length > 0) {
        data.text = response.data.broadcasts[0].title
      }

    } catch (error) {
      console.error(error)
    }

    return data
  },

  async getAirTimeInfo() {
    const data = {
      text: '',
      onAir: true
    };

    try {
      const response = await axios.get(this.airTime);
      const info = response.data.tracks.current;

      if (info.type === 'livestream' && response.data.tracks.current.name.length > 0) {
        data.text = 'Live: ' + response.data.tracks.current.name;
      } else if (info.name) {
        let isLive = response.data.shows.current.name.toLowerCase().indexOf('live:') === 0
        data.text = ( isLive ? '' :  'Replay: ') + response.data.tracks.current.name;
      }


      if (info.type === 'livestream' && data.text.length === 0) {

        let events = await this.getPosts(3, 'future');

        if (events[0]) {
          let currentEvent = events[0];
          data.text = currentEvent.title
            +  (currentEvent.location && currentEvent.location.post_title ? ' | Live from ' + currentEvent.location.post_title : '');
        }
      }

    } catch (error) {
      let shows = await this.getPosts(3, 'future', onSuccess)
    }

    return data;
  },

  async getPosts(category, preset) {
    let response = await axios.get(this.cms + `?categories=${category}&preset=${preset}`)

    return PostUtil.transformPosts(
      response.data
    )
  },

}
